<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.tab-pane.card-body
    h2.mb-4(v-html="$t('tabs.basevalues.title')")

    //- Multistory Formgroup
    .form-group.border-bottom.pb-4.mb-4
        div
            label.label-title(v-html="$t('tabs.basevalues.multistory.label')")
            help-text-modal(:body="$t('tabs.basevalues.multistory.helptext')")
        .custom-control.custom-control-inline.custom-radio
            input#multistory1.custom-control-input(type="radio", v-model="protocol.data.multistory", :value="true")
            label.custom-control-label(for="multistory1") ja, mehrgeschossig
        .custom-control.custom-control-inline.custom-radio
            input#multistory0.custom-control-input(type="radio", v-model="protocol.data.multistory", :value="false")
            label.custom-control-label(for="multistory0") nein, eingeschossig
        small.form-text.text-muted(v-html="$t('tabs.basevalues.multistory.description')")

    //- n50available Formgroup
    .form-group.border-bottom.pb-4.mb-4(v-if="protocol.data.multistory !== undefined")
        div
            label.label-title(v-html="$t('tabs.basevalues.n50available.label')")
            help-text-modal(:body="$t('tabs.basevalues.n50available.helptext')")
        .custom-control.custom-control-inline.custom-radio
            input#n50available1.custom-control-input(type="radio", v-model="n50available", :value="true")
            label.custom-control-label(for="n50available1") ja, vorhanden
        .custom-control.custom-control-inline.custom-radio
            input#n50available0.custom-control-input(type="radio", v-model="n50available", :value="false")
            label.custom-control-label(for="n50available0") nein, nicht vorhanden
        small.form-text.text-muted(v-html="$t('tabs.basevalues.n50available.description')")

    //- n50measured Formgroup
    .form-group(v-if="n50available === true")
        label.label-title(v-html="$t('tabs.basevalues.n50measured.label')")
        numeric-input(v-model.number="protocol.data.n50measured")
        .small.mt-4(v-if="protocol.fWirkKomp")
            span(v-html="$t('tabs.basevalues.n50measured.resultf', { f: protocol.fWirkKomp })")
        .small(v-if="protocol.n")
            span(v-html="$t('tabs.basevalues.n50measured.resultn', { n: protocol.n })")

    //- houseType Formgroup
    .form-group(v-if="n50available === false")
        label.label-title(v-html="$t('tabs.basevalues.housetype.label')")
        .row.d-flex.align-items-center
            .col
                .custom-control.custom-control-inline.custom-radio(v-for="option in houseTypeOptions")
                    input.custom-control-input(
                        type="radio",
                        :id="`houseType${option}`",
                        v-model="protocol.data.houseType",
                        :value="option"
                    )
                    label.custom-control-label(:for="`houseType${option}`") Haustyp {{ option }}
            .col.border-left.text-center.py-3
                haustyp-assistant(v-model="protocol.data.houseType", :mehrgeschossig="protocol.data.multistory")
        small.form-text.text-muted(v-html="$t('tabs.basevalues.housetype.description')")

    button.btn.btn-primary(v-if="validBaseValues", @click="saveAndContinue") Speichern &amp; Weiter
</template>

<script>
import HaustypAssistant from '@/components/HaustypAssistant'
import HelpTextModal from '@/components/HelpTextModal'
import NumericInput from '@/components/NumericInput'
import { Protocol } from 'trgi'

export default {
    components: {
        HaustypAssistant,
        HelpTextModal,
        NumericInput
    },
    props: {
        value: {
            type: Protocol,
            default: function () {
                return new Protocol()
            }
        }
    },
    data () {
        const protocol = new Protocol(this.value)

        let n50available // undefined is used as a third state!
        if (protocol.data.houseType) {
            n50available = false
        }
        if (protocol.data.n50measured) {
            n50available = true
        }

        return {
            n50available,
            protocol
        }
    },
    computed: {
        validBaseValues: function () {
            if (this.n50available === false && this.protocol.data.houseType) {
                return true
            }
            if (this.n50available === true && this.protocol.fWirkKomp && this.protocol.n) {
                return true
            }
            return false
        },
        houseTypeOptions: function () {
            if (this.protocol.data.multistory === true) {
                return [2, 4, 6, 7]
            }
            if (this.protocol.data.multistory === false) {
                return [1, 3, 5, 7]
            }
            return [1, 2, 3, 4, 5, 6, 7]
        }
    },
    watch: {
        // When Protocol gets modified on another Tab, refresh Local Protocol Variable
        value (value) {
            this.protocol = new Protocol(value)
        }
    },
    methods: {
        saveAndContinue () {
            // There is either a n50measured or a houseType - unset the unused values
            if (this.n50available === true) {
                this.protocol.data.houseType = undefined
            }
            if (this.n50available === false) {
                this.protocol.data.n50measured = undefined
            }

            this.$emit('save', new Protocol(this.protocol))
        }
    }
}
</script>
